import React from 'react';
import ImgLoader from '../ImgLoader';
import { Box, ThemeUIStyleObject } from 'theme-ui';
import { Image } from '~/types';
type Props = {
  image: Image;
  imageMobile?: Image;
  forwardSx?: ThemeUIStyleObject;
};
const ModalImage = ({ image, imageMobile, forwardSx }: Props) => {
  return (
    <Box sx={{ height: '100%', maxHeight: ['20rem', '100%'], mb: ['0.8rem', 0], ...forwardSx }}>
      <ImgLoader image={image} forwardSx={{ display: [!!imageMobile ? 'none' : 'block', 'block'], height: '100%' }} />
      {imageMobile ? (
        <ImgLoader
          image={imageMobile}
          forwardSx={{ display: ['block', 'none'], height: '100%' }}
          objectPosition="top"
        />
      ) : null}
    </Box>
  );
};

export default ModalImage;
